import { List } from 'immutable';
import { Themes } from 'records/Theme';
import BaseList from 'records/BaseList';

import {
  THEMES_OCCASION_ASYNC_ACTION_START,
  THEMES_OCCASION_ASYNC_ACTION_SUCCESS,
  THEMES_OCCASION_ASYNC_ACTION_ERROR,
  THEMES_OCCASION_RESET_STATE,
} from 'actions/themesOccasion';

const initialState = new BaseList({
  loading: false,
  errorMessage: null,
  data: new List(),
});

const actionsMap = {
  [THEMES_OCCASION_ASYNC_ACTION_START]: (state) => {
    return state.merge({
      loading: true,
      errorMessage: null,
    });
  },
  [THEMES_OCCASION_ASYNC_ACTION_ERROR]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: action.error,
    });
  },
  [THEMES_OCCASION_ASYNC_ACTION_SUCCESS]: (state, action) => {
    const themesOccasionData = Themes(action.data);
    return state.merge({
      loading: false,
      errorMessage: null,
      data: themesOccasionData,
    });
  },
  [THEMES_OCCASION_RESET_STATE]: () => {
    return initialState;
  },
};

export default function themesOccasion(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
